/**
 * @flow
 * @relayHash 04673b9e7d560d396e19bec20c587831
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getJobContractPreviewQueryVariables = {|
  jobId: string
|};
export type getJobContractPreviewQueryResponse = {|
  +previewJobContract: ?{|
    +pdfFile: ?string,
    +errors: ?$ReadOnlyArray<?string>,
  |}
|};
export type getJobContractPreviewQuery = {|
  variables: getJobContractPreviewQueryVariables,
  response: getJobContractPreviewQueryResponse,
|};
*/


/*
query getJobContractPreviewQuery(
  $jobId: ID!
) {
  previewJobContract(jobId: $jobId) {
    pdfFile
    errors
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "jobId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "previewJobContract",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "jobId",
        "variableName": "jobId"
      }
    ],
    "concreteType": "PreviewContractPDF",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "pdfFile",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "errors",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getJobContractPreviewQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getJobContractPreviewQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getJobContractPreviewQuery",
    "id": null,
    "text": "query getJobContractPreviewQuery(\n  $jobId: ID!\n) {\n  previewJobContract(jobId: $jobId) {\n    pdfFile\n    errors\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '41437938ec41134c3691c64a43ec0559';
module.exports = node;
